import React, { useMemo } from "react";
import LarvaBreeding from "services/LarvaBreeding";
import { errorToastNotif } from "utils/common";
import {
  buildTpCodeMap,
  getDensity,
  formatLarvaPhase,
  hasInterventionType,
  getInterventionOthers,
  isBelumIntervensi,
  getInterventionBelum,
} from "./utils";
import {
  getLarvicideTypeDisplay,
  getLarvicideFormDisplay,
  getLarvicideAmountDisplay,
  getLarvicideUnitDisplay,
} from "pages/Vektor/FlickIdentification/LarvaBreedingIntervention/utils/larvicide";

const LarvaBreedingService = new LarvaBreeding();

export default function TableComponent({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
}) {
  const levelLower = String(currentLevel || "").toLowerCase();
  const isNational = levelLower === "national";
  const isProvince = levelLower === "province";

  let levelName = "";
  if (isNational) {
    levelName = "Nasional";
  } else if (isProvince) {
    levelName = "Provinsi";
  } else if (levelLower === "district") {
    levelName = "Kabupaten/Kota";
  } else {
    levelName = "Fasyankes";
  }

  const faskesName = (() => {
    const data = reportInfo?.fasyankes;
    if (!data) return "Semua Fasyankes";
    const parts = data.split(",");
    const names = parts.map((part) => part?.split("|")[1] || part);
    return names.join(", ");
  })();

  const regionColsCount = isNational ? 4 : isProvince ? 3 : 2;
  const allColumnsCount = 1 + regionColsCount + 36;

  const dataRows = reportsData ?? [];
  const tpCodeMap = useMemo(() => buildTpCodeMap(dataRows), [dataRows]);

  const handleViewImage = async (id, kind) => {
    if (!id) return;
    try {
      const blob =
        kind === "larva"
          ? await LarvaBreedingService.getImageLarva(id)
          : await LarvaBreedingService.getImage(id);
      const fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
    } catch (err) {
      console.log(err);
      errorToastNotif(err);
    }
  };

  return (
    <div className="table-table-responsive" ref={tableRef}>
      <table>
        <tbody>
          <tr style={{ border: "none", padding: 0 }}>
            <th style={{ border: "none", paddingBottom: "0" }}>
              <h3>SISMAL v3, LAPORAN REKAP KOHORT LENGKAP</h3>
            </th>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr style={{ border: "none" }}>
            <th
              width="200"
              style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}
            >
              Periode Laporan
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {reportInfo?.statusPeriode || "-"}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Tahun
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {reportInfo?.periode || "-"}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Bulan
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {reportInfo?.bulan || "Semua Bulan"}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Level
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {levelName}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Provinsi
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.province
                ? "Semua Provinsi"
                : reportInfo?.province?.split("|")[1] || reportInfo?.province}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Kab/Kota
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.district
                ? "Semua Kab/Kota"
                : reportInfo?.district?.split("|")[1] || reportInfo?.district}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0 }}>Fasyankes</th>
            <th style={{ border: "none", paddingTop: 0 }}>: {faskesName}</th>
          </tr>
        </tbody>
      </table>

      <table>
        <thead>
          <tr>
            <th>No.</th>
            {isNational && <th>Provinsi</th>}
            {(isNational || isProvince) && <th>Kabupaten/Kota</th>}
            <th>Fasyankes</th>
            <th>Desa</th>
            <th>Kode TP</th>
            <th>Follow-up Ke</th>
            <th>Tanggal</th>
            <th>Petugas</th>
            <th>Status TP</th>
            <th>Penyebab Hilangnya TP</th>
            <th>Jentik?</th>
            <th>Jml Cidukan</th>
            <th>Jml Jentik</th>
            <th>Kepadatan</th>
            <th>Instar</th>
            <th>Luas</th>
            <th>Kedalaman</th>
            <th>Jarak dari Permukiman</th>
            <th>Kekeruhan</th>
            <th>Tanaman Air</th>
            <th>Sampah</th>
            <th>Sifat TP</th>
            <th>Paparan Matahari</th>
            <th>Air Payau</th>
            <th>Air Mengalir</th>
            <th>Ada Ikan</th>
            <th>Intervensi (Sudah/Belum)</th>
            <th>Larvasidasi</th>
            <th>Jenis Larvasida</th>
            <th>Bentuk Larvasida</th>
            <th>Jumlah Larvasida</th>
            <th>Satuan</th>
            <th>Penebaran Ikan</th>
            <th>Modifikasi Lingkungan</th>
            <th>Manipulasi Lingkungan</th>
            <th>Intervensi lainnya</th>
            <th>Belum Intervensi</th>
            <th>Rencana Intervensi</th>
            <th data-export-exclude>Foto TP</th>
            <th data-export-exclude>Foto Jentik</th>
          </tr>
        </thead>
        <tbody>
          {dataRows.length ? (
            dataRows.map((row, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                {isNational && <td>{row?.provinsi ?? "-"}</td>}
                {(isNational || isProvince) && <td>{row?.kabupaten ?? "-"}</td>}
                <td>{row?.fasyankes ?? "-"}</td>
                <td>{row?.desa ?? "-"}</td>
                <td>{tpCodeMap.get(row?.tp_id) ?? "-"}</td>
                <td>{row?.follow_up_ke ?? "-"}</td>
                <td>{row?.tanggal ?? "-"}</td>
                <td>{row?.officer_team || "-"}</td>
                <td>{row?.status || "-"}</td>
                <td>{row?.tp_gone_reason || "-"}</td>
                <td>{row?.anopheles_larva_found || "-"}</td>
                <td>{row?.total_catch ?? "-"}</td>
                <td>{row?.total_larva ?? "-"}</td>
                <td>{getDensity(row)}</td>
                <td>{formatLarvaPhase(row?.larva_phase)}</td>
                <td>{row?.area_breeding_place ?? "-"}</td>
                <td>{row?.depth_breeding_place ?? "-"}</td>
                <td>{row?.distance_to_nearest_house ?? "-"}</td>
                <td>{row?.water_turbidity || "-"}</td>
                <td>{row?.plan_exist_breeding_place || "-"}</td>
                <td>{row?.rubbish_exist_breeding_place || "-"}</td>
                <td>{row?.trait_breeding_place || "-"}</td>
                <td>{row?.sun_exposure || "-"}</td>
                <td>{row?.brackish_water || "-"}</td>
                <td>{row?.running_water || "-"}</td>
                <td>{row?.fish_exist || "-"}</td>
                <td>{row?.has_actual_intervention ? "Sudah" : "Belum"}</td>
                <td>
                  {hasInterventionType(row?.intervention_done, "Larvasidasi")}
                </td>
                <td>{getLarvicideTypeDisplay(row)}</td>
                <td>{getLarvicideFormDisplay(row)}</td>
                <td>{getLarvicideAmountDisplay(row)}</td>
                <td>{getLarvicideUnitDisplay(row)}</td>
                <td>
                  {hasInterventionType(row?.intervention_done, "Penebaran Ikan")}
                </td>
                <td>
                  {hasInterventionType(
                    row?.intervention_done,
                    "Modifikasi Lingkungan"
                  )}
                </td>
                <td>
                  {hasInterventionType(
                    row?.intervention_done,
                    "Manipulasi Lingkungan"
                  )}
                </td>
                <td>{getInterventionOthers(row?.intervention_done)}</td>
                <td>{isBelumIntervensi(row?.intervention_done)}</td>
                <td>{getInterventionBelum(row?.intervention_done)}</td>
                <td data-export-exclude>
                  {row?.image ? (
                    <button
                      type="button"
                      className="link-button"
                      onClick={() => handleViewImage(row?.intervensi_id, "tp")}
                    >
                      Lihat Foto
                    </button>
                  ) : (
                    "-"
                  )}
                </td>
                <td data-export-exclude>
                  {row?.image_larva ? (
                    <button
                      type="button"
                      className="link-button"
                      onClick={() =>
                        handleViewImage(row?.intervensi_id, "larva")
                      }
                    >
                      Lihat Foto
                    </button>
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={allColumnsCount}>Tidak Ada Data</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
